export function isQ3Enabled() {
  return process.env.REACT_APP_Q3_PANCHANG_ENABLED === 'true';
}

export function isPanchangMockEnabled() {
  return process.env.REACT_APP_PANCHANG_MOCK === 'true';
}
